import React from 'react'

const UnitsIcon = ({ariaHidden}) => (
  <svg
    aria-hidden={ariaHidden}
    width="24px"
    height="24px"
    viewBox="0 0 32 32"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
    >
      <g fill="#CCCCCC">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.666667 0H31.3333C31.7015 0 32 0.298477 32 0.666667V31.3333C32 31.7015 31.7015 32 31.3333 32H0.666667C0.298477 32 0 31.7015 0 31.3333V0.666667C0 0.298477 0.298477 0 0.666667 0ZM12 26.6667V30.6667H20V26.6667C20 24.4613 18.2053 22.6667 16 22.6667C13.7947 22.6667 12 24.4613 12 26.6667ZM30.6667 30.6667H21.3333V26.6667C21.3333 23.7253 18.9413 21.3333 16 21.3333C13.0587 21.3333 10.6667 23.7253 10.6667 26.6667V30.6667H1.33333V1.33333H30.6667V30.6667ZM28.6667 20H23.3333C22.9651 20 22.6667 20.2985 22.6667 20.6667V27.3333C22.6667 27.7015 22.9651 28 23.3333 28H28.6667C29.0349 28 29.3333 27.7015 29.3333 27.3333V20.6667C29.3333 20.2985 29.0349 20 28.6667 20ZM28 26.6667H24V21.3333H28V26.6667ZM8.66667 28H3.33333C2.96514 28 2.66667 27.7015 2.66667 27.3333V20.6667C2.66667 20.2985 2.96514 20 3.33333 20H8.66667C9.03486 20 9.33333 20.2985 9.33333 20.6667V27.3333C9.33333 27.7015 9.03486 28 8.66667 28ZM8 21.3333H4V26.6667H8V21.3333ZM10 17.3333H3.33333C2.96514 17.3333 2.66667 17.0349 2.66667 16.6667V3.33333C2.66667 2.96514 2.96514 2.66667 3.33333 2.66667H10C10.3682 2.66667 10.6667 2.96514 10.6667 3.33333V16.6667C10.6667 17.0349 10.3682 17.3333 10 17.3333ZM4 16H9.33333V10.6667H4V16ZM4 4H9.33333V9.33333H4V4ZM12.6667 17.3333H19.3333C19.7015 17.3333 20 17.0349 20 16.6667V3.33333C20 2.96514 19.7015 2.66667 19.3333 2.66667H12.6667C12.2985 2.66667 12 2.96514 12 3.33333V16.6667C12 17.0349 12.2985 17.3333 12.6667 17.3333ZM18.6667 16H13.3333V10.6667H18.6667V16ZM18.6667 4H13.3333V9.33333H18.6667V4ZM28.6667 17.3333H22C21.6318 17.3333 21.3333 17.0349 21.3333 16.6667V3.33333C21.3333 2.96514 21.6318 2.66667 22 2.66667H28.6667C29.0349 2.66667 29.3333 2.96514 29.3333 3.33333V16.6667C29.3333 17.0349 29.0349 17.3333 28.6667 17.3333ZM22.6667 16H28V10.6667H22.6667V16ZM22.6667 4H28V9.33333H22.6667V4Z"
        />
      </g>
    </g>
  </svg>
)

export default UnitsIcon
